<template>
  <div class="shoppingCart">
    <div v-if="cartList.valid.length > 0 || cartList.invalid.length > 0">
      <div class="list">
        <div v-for="(m, i) in cartList.valid" :key="i">
          <div class="market_name">
            <div>{{m.market_name}}</div>
          </div>

          <div
            class="item acea-row row-between-wrapper"
            v-for="(item,index) in m.goods"
            :key="index"
          >
            <div class="picTxt acea-row row-between-wrapper">
              <div class="pictrue" @click="$router.push({ path: '/detail/' + item.product_id })">
                <img :src="item.productInfo.attrInfo.image" v-if="item.productInfo.attrInfo" />
                <img :src="item.productInfo.image" v-else />
              </div>
              <div class="text">
                <div class="line1">{{ item.productInfo.store_name }}</div>
                <div
                  class="infor line1"
                  v-if="item.productInfo.attrInfo"
                >属性：{{ item.productInfo.attrInfo.suk }}</div>
                <div class="money">￥{{ item.truePrice }}</div>
              </div>
              <div class="carnum acea-row row-center-wrapper">
                <div class="reduce" @click.prevent="reduce(i,index)">-</div>
                <div class="num">{{ item.cart_num }}</div>
                <div
                  class="plus"
                  @click.prevent="plus(i,index)"
                >+</div>
              
              </div>
            </div>
          </div>

          <div class="footers acea-row row-between-wrapper">
            <div>
              <div class="select-btn">
                <div class="checkbox-wrapper">
                  <span class="font-color-red">￥{{ m.total_money }}</span>
                </div>
              </div>
            </div>
            <div class="money acea-row row-middle">
              <div class="placeOrder bg-color-red btns" @click="placeOrder(i,m.market_id)">立即结算</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--购物车暂无商品-->
    <div class="noCart" v-if="cartList.valid.length === 0 && cartList.invalid.length === 0">
      <div class="pictrue">
        <img src="@assets/images/noCart.png" />
      </div>
      <Recommend></Recommend>
    </div>
    <div style="height:2.1rem"></div>
  </div>
</template>
<script>
import Recommend from "@components/Recommend";
import {
  getCartList,
  postCartDel,
  changeCartNum,
  getCartCount
} from "@api/store";
import { postCollectAll } from "@api/user";
import { mul, add } from "@utils/bc";
import cookie from "@utils/store/cookie";
import debounce from "lodash.debounce";

const CHECKED_IDS = "cart_checked";

export default {
  name: "ShoppingCart",
  components: {
    Recommend
  },
  props: {},
  data: function() {
    return {
      cartList: { invalid: [], valid: [] },
      isAllSelect: false,
      cartCount: 0,
      countmoney: 0,
      goodsHidden: true,
      footerswitch: false,
      count: 0,
      checkedIds: [],
      loaded: false
    };
  },
  watch: {
    $route(n) {
      if (n.name === "ShoppingCart") {
        this.getCartList();
        this.goodsHidden = true;
        this.footerswitch = false;
      }
    }
  },
  mounted: function() {
    let that = this;
    that.getCartList();
  },
  methods: {
    getCartList: function() {
      let that = this;
      getCartList().then(res => {
        that.cartList = res.data;
        this.loaded = true;
      });
    },
    //删除商品；
    delgoods: function() {
      let that = this,
        id = [],
        valid = [],
        list = that.cartList.valid;
      list.forEach(function(val) {
        if (val.checked === true) {
          id.push(val.id);
        }
      });
      if (id.length === 0) {
        that.$dialog.toast({ mes: "请选择产品" });
        return;
      }
      postCartDel(id).then(function() {
        list.forEach(function(val, i) {
          if (val.checked === false || val.checked === undefined)
            valid.push(list[i]);
        });
        that.$set(that.cartList, "valid", valid);
        that.carnum();
        that.countMoney();
        that.gainCount();
      });
    },
    // //获取数量
    gainCount: function() {
      let that = this;
      getCartCount().then(res => {
        that.count = res.data.count;
      });
    },
    //清除失效产品；
    delInvalidGoods: function() {
      let that = this,
        id = [],
        list = that.cartList.invalid;
      list.forEach(function(val) {
        id.push(val.id);
      });
      postCartDel(id).then(function() {
        list.splice(0, list.length);
        that.gainCount();
      });
    },
    //立即下单；
    placeOrder: function(i, market) {
      let that = this,
        list = that.cartList.valid[i].goods,
        id = [];
      list.forEach(function(val) {
        id.push(val.id);
      });
      if (id.length === 0) {
        that.$dialog.toast({ mes: "请选择产品" });
        return;
      }

      this.$router.push({
        path: "/order/submit",
        query: { id: id.toString(), market: market }
      });
    },
    manage: function() {
      let that = this;
      that.footerswitch = !that.footerswitch;
    },
    goodsOpen: function() {
      let that = this;
      that.goodsHidden = !that.goodsHidden;
    },
    //加
    plus: function(i, index) {
      let that = this;
      let list = that.cartList.valid[i].goods[index];
      list.cart_num++;
      
      that.carnum();
      that.countMoney(i);
      that.syncCartNum(list);
    },
    //减
    reduce: function(i, index) {
      let that = this;
      let list = that.cartList.valid[i].goods[index];
      list.cart_num--;
      if (list.cart_num < 1) {
        var cart = that.cartList.valid[i].goods;
        cart.splice(index, 1);
        that.cartList.valid[i].goods = cart;
        postCartDel(list.id).then(function() {});
      }
      that.carnum();
      that.countMoney(i);
      that.syncCartNum(list);
    },
    syncCartNum(cart) {
      if (!cart.sync)
        cart.sync = debounce(() => {
          changeCartNum(cart.id, Math.max(cart.cart_num, 1) || 1);
        }, 500);

      cart.sync();
    },
    //数量
    carnum: function() {
      return 0;
    },
    //总共价钱；
    countMoney: function(i) {
      let that = this;
      let carmoney = 0;
      let array = that.cartList.valid[i].goods;
      for (let i = 0; i < array.length; i++) {
        carmoney = add(carmoney, mul(array[i].cart_num, array[i].truePrice));
      }
      that.cartList.valid[i].total_money = carmoney;
    }
  }
};
</script>

<style scoped>
.market_name {
  display: flex;
  justify-content: center;
  font-size: 0.4rem;
  font-weight: 700;
  height: 0.6rem;
}
.shoppingCart .list {
  margin-top: 0.2rem;
}

.shoppingCart .footers {
  width: 100%;
  height: 0.96rem;
  background-color: #fafafa;
  bottom: 1rem;
  padding: 0 0.3rem;
  border-top: 1px solid #eee;
}
.shoppingCart .btns {
  color: #fff;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 1.6rem;
  text-align: center;
  border-radius: 0.3rem;
}
</style>